var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCheckRed(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.5087 7.87569L9.47745 17.9069C9.24305 18.1412 8.92523 18.2728 8.59386 18.2728C8.26248 18.2728 7.94466 18.1412 7.71026 17.9069L2.11495 12.2819C1.88094 12.0476 1.74951 11.7299 1.74951 11.3987C1.74951 11.0676 1.88094 10.7499 2.11495 10.5155L3.67745 8.95304C3.91172 8.71975 4.22887 8.58877 4.55948 8.58877C4.89009 8.58877 5.20724 8.71975 5.44151 8.95304L8.62511 12.0405L16.1845 4.57413C16.4188 4.3406 16.7361 4.20947 17.0669 4.20947C17.3977 4.20947 17.715 4.3406 17.9493 4.57413L19.5079 6.10069C19.6251 6.21684 19.7182 6.35506 19.7817 6.50735C19.8452 6.65965 19.878 6.82301 19.8781 6.98803C19.8781 7.15304 19.8455 7.31644 19.7821 7.46879C19.7187 7.62114 19.6258 7.75944 19.5087 7.87569Z",
    fill: "#F04438"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckRed);
export default __webpack_public_path__ + "static/media/check-red.56e74cd70120764d66dfc6d8ac2ed30a.svg";
export { ForwardRef as ReactComponent };